import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import { Gunzip } from 'fflate';
import { sampleTech } from 'utils/constants';
import techOptions from 'utils/upload/fileUploadUtils';
import readFileToBuffer from 'utils/upload/readFileToBuffer';
var Verdict = {
  INVALID_NAME: -2,
  INVALID_FORMAT: -1,
  VALID_ZIPPED: 0,
  VALID_UNZIPPED: 1
};
var MATRIX_SIGNATURE = Buffer.from('%%MatrixMarket');
var GZIP_SIGNATURE = Buffer.from([0x1f, 0x8b]);
var getShouldCompress = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var data, hasGzipSignature;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readFileToBuffer(file.slice(0, 16));
          case 2:
            data = _context.sent;
            hasGzipSignature = !data.slice(0, 2).compare(GZIP_SIGNATURE);
            return _context.abrupt("return", hasGzipSignature ? Verdict.VALID_ZIPPED : Verdict.VALID_UNZIPPED);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getShouldCompress(_x) {
    return _ref.apply(this, arguments);
  };
}();
var inspectFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, technology) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(Object.values(sampleTech).includes(technology) && !techOptions[technology].isNameValid(file.name))) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", Verdict.INVALID_NAME);
          case 2:
            if (!(technology === sampleTech['10X'])) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", inspect10XFile(file));
          case 4:
            if (!(technology === sampleTech.SEURAT)) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return", Verdict.VALID_ZIPPED);
          case 6:
            if (!(technology === sampleTech.RHAPSODY)) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", inspectRhapsodyFile(file));
          case 8:
            if (!(technology === sampleTech.H5)) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", inspectH5File(file));
          case 10:
            if (!(technology === sampleTech.PARSE)) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return", inspectParseFile(file));
          case 12:
            return _context2.abrupt("return", Verdict.INVALID_FORMAT);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function inspectFile(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var inspectH5File = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (techOptions[sampleTech.H5].isNameValid(file.name)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", Verdict.INVALID_NAME);
          case 2:
            _context3.next = 4;
            return getShouldCompress(file);
          case 4:
            return _context3.abrupt("return", _context3.sent);
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function inspectH5File(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var inspect10XFile = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(file) {
    var data, verdict, _gunzip;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return readFileToBuffer(file.slice(0, 16));
          case 2:
            data = _context4.sent;
            _context4.next = 5;
            return getShouldCompress(file);
          case 5:
            verdict = _context4.sent;
            if (!(verdict === Verdict.VALID_ZIPPED)) {
              _context4.next = 13;
              break;
            }
            // if gzipped, decompress a small chunk to further validate contents
            _gunzip = new Gunzip(function (chunk) {
              data = Buffer.from(chunk.slice(0, 16));
            });
            _context4.t0 = _gunzip;
            _context4.next = 11;
            return readFileToBuffer(file.slice(0, 128));
          case 11:
            _context4.t1 = _context4.sent;
            _context4.t0.push.call(_context4.t0, _context4.t1);
          case 13:
            if (!(file.name.match(/.*(matrix.mtx|matrix.mtx.gz)$/i) && !data.slice(0, MATRIX_SIGNATURE.length).compare(MATRIX_SIGNATURE))) {
              _context4.next = 15;
              break;
            }
            return _context4.abrupt("return", verdict);
          case 15:
            if (!file.name.match(/.*(genes.tsv|genes.tsv.gz|features.tsv|features.tsv.gz)$/i)) {
              _context4.next = 17;
              break;
            }
            return _context4.abrupt("return", verdict);
          case 17:
            if (!(file.name.match(/.*(barcodes.tsv|barcodes.tsv.gz)$/i) && !data.toString().match(/\t/))) {
              _context4.next = 19;
              break;
            }
            return _context4.abrupt("return", verdict);
          case 19:
            return _context4.abrupt("return", Verdict.INVALID_FORMAT);
          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function inspect10XFile(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
var inspectRhapsodyFile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(file) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getShouldCompress(file);
          case 2:
            return _context5.abrupt("return", _context5.sent);
          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function inspectRhapsodyFile(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
var inspectParseFile = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(file) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getShouldCompress(file);
          case 2:
            return _context6.abrupt("return", _context6.sent);
          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function inspectParseFile(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
export { inspectFile, Verdict, getShouldCompress };